import { useEffect, useState } from "react";
import useKitInconsistencyDetector from "./KitInconsistencyDetector";
import { PackagingType } from "../../api/KitApi";

interface Props {
  readonly customerId: number;
  readonly kitId: number;
  readonly packagingType: PackagingType;
  readonly timestamp: Date;
}

export const KitStatus = (props: Props) => {
  const kitInconsistencyDetector = useKitInconsistencyDetector();
  const customerId = props.customerId;
  const kitId = props.kitId;
  const [kitStatus, setKitStatus] = useState<string>('...');

  useEffect(() => {
    console.info(`useEffect: ${customerId}`);
    if (props.packagingType === 'specification') {
      kitInconsistencyDetector
        .detectInconsistenciesBetweenKitSpecificationAndPackagingSpecification(customerId, kitId)
        .then(inconsistencies => setKitStatus(
          inconsistencies.length === 0
            ? 'ok'
            : `problemów: ${inconsistencies.length}`));
    } else {
      setKitStatus('ok');
    }
  }, [customerId, kitId, props.timestamp]);

  return <div>{kitStatus}</div>
}